import React from "react";
import "./createNextFinalsTournamentRoundBtn.scss";

const CreateNextFinalsTournamentRoundBtn = ({
  onClick,
  style = {},
  className = "",
  disabled,
  text = "Next Finals Tournament Round",
  icon: IconComponent,
  width,
}) => {
  const dynamicStyle = disabled
    ? { color: "black", cursor: "not-allowed" }
    : { color: "#b03a2e" };

  return (
    <button
      type="button"
      style={{
        width,
        ...dynamicStyle,
        ...style,
      }}
      className={`create-next-finals-tournament-round-btn ${className}`}
      onClick={onClick}
      disabled={disabled}
      aria-disabled={disabled ? "true" : "false"}
    >
      {IconComponent && (
        <span className="create-next-finals-tournament-round-btn-icon">
          <IconComponent
            fillColor={dynamicStyle.color}
            strokeColor={dynamicStyle.color}
          />
        </span>
      )}
      {text}
    </button>
  );
};

export default CreateNextFinalsTournamentRoundBtn;